/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialCompanyDiscountResponse } from '../../models/editorial-company-discount-response';

export interface GetEditorialCompanyDiscount$Params {
  companyId: number;
  discountId: number;
}

export function getEditorialCompanyDiscount(http: HttpClient, rootUrl: string, params: GetEditorialCompanyDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompanyDiscountResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialCompanyDiscount.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.path('discountId', params.discountId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialCompanyDiscountResponse>;
    })
  );
}

getEditorialCompanyDiscount.PATH = '/api/editorial/companies/{companyId}/discounts/{discountId}';
